import React from 'react';
import ReactDOM from 'react-dom';
import defaultUserThumb from '../../lib/images/user-thumb-default.png'
import moment from 'moment/min/moment-with-locales';
import jump from 'jump.js'
import Modal from '../App/Modal'

moment.locale('ja')

export default class Component extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      editMode: false,
      commentContent: this.props.comment ? this.props.comment.content : "",
      "comment[content]": "",
      openModal: false
    }
  }

  valueChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value
    })
  }

  nl2br = (text) => {
    var regex = /(\r\n|\n|\r)/gm
    return text.split(regex).map(function (line) {
      if (line.match(regex)) {
        return React.createElement('br')
      }
      else {
        return line;
      }
    });
  }

  deleteModalOpen = () => {
    this.setState({ openModal: true })
  }

  deleteModalCancel = () => {
    this.setState({ openModal: false })
  }

  deleteConfirm = () => {
    const html = window.document.documentElement;
    html.classList.remove('slideout-open')
    this.setState({ editMode: false, openModal: false })
    this.props.destroyComment(this.props.comment.id, this.props.circle.id)
  }


  editCommentMode = (e) => {
    // ウインドウサイズ
    const windowHeight = document.documentElement.clientHeight;
    const mainObject = document.getElementById('panel')
    // mainタグの高さ

    const mainScrollHeight = mainObject.scrollHeight
    // ターゲット
    const targetCard = document.getElementById('commentCard'+this.props.comment.id)
    // ターゲットの相対的位置
    const targetOffsetTop = targetCard.offsetTop
    const HeaderHeight = document.querySelector('.circleHeader').scrollHeight
    const inputHeight = document.querySelector('.postCreateFieldWrap').scrollHeight
    const cardHeadHeight = document.querySelector(`#postCard${this.props.post.id} .postMetaInfo`).scrollHeight
    const postBodyHeight = document.querySelector(`#postCard${this.props.post.id} .postContentWrap`).scrollHeight
    const commentBoxTopHeight = Number(document.querySelector(`#postCard${this.props.post.id} .commentsWrap`).style.paddingTop.replace('px',''))

    // ターゲットの絶対位置
    const targetTop = targetOffsetTop + HeaderHeight + inputHeight + cardHeadHeight + postBodyHeight + commentBoxTopHeight + 10
    const targetHeight = targetCard.clientHeight
    const targetBottomPosition = targetTop + targetHeight
    const targetBottomBlankHeight = mainScrollHeight - targetBottomPosition
    const needBlankHeight = windowHeight - targetHeight
    const canScroll = needBlankHeight <= targetBottomBlankHeight

    if (!canScroll) {
      mainObject.style.height = `${mainScrollHeight + (needBlankHeight - targetBottomBlankHeight + 50)}px`
    }

    this.setState({ editMode: true })
  }

  removeEditCommentMode = () => {
    const mainObject = document.getElementById('panel')
    mainObject.style.height = 'auto'
    jump(-40, {
      duration: 200
    })
    this.setState({ editMode: false })
  }

  updateComment = () => {
    jump(-40, {
      duration: 200
    })
    this.props.updateComment(this.state.commentContent, this.props.comment.id, this.props.circle.id)
    this.setState({ editMode: false })
  }

  componentDidUpdate = () => {

    const targetCommentCard = document.getElementById('commentCard' + this.props.comment.id)
    const header = document.getElementById('appHeader')
    const html = window.document.documentElement;

    if (this.state.editMode && targetCommentCard.classList.contains('openComment')) {
      // 編集モードのとき
      const targetHeight = targetCommentCard.offsetHeight
      const nextComment = targetCommentCard.nextElementSibling
      // const beforeComment = targetCommentCard.previousElementSibling
      
      if (nextComment) {

        const commentCards = document.querySelectorAll(`#postCard${this.props.post.id} .commentCard`)

        if (commentCards.length > 0) {
          const blankHeight = targetHeight + 20
          nextComment.style.marginTop = `${blankHeight}px`
          nextComment.classList.add('nextComment')
        } else {
          // // const commentsList = document.querySelector(`#postCard${this.props.post.id} .commentsList`)
          // // commentsList.style.minHeight = `${targetHeight}px`
          // // commentsList.classList.add('openWrap')

          // beforeComment.style.height = `${targetHeight}px`
          // beforeComment.classList.add = 'beforeBlank'
        }

      } else {
        // const blankHeight = targetHeight + 10
        // beforeComment.classList.add('beforeComment')
        // beforeComment.style.marginBottom = `${blankHeight}px`
      }

      if (!header.classList.contains('panel-open')) {
        header.classList.add('panel-open')
        if (header.classList.contains('fadein')) {
          header.classList.remove('fadein')
        }
        header.classList.add('fadeout')
      }

      html.classList.add('slideout-open')
    } else {
      //編集モードではない時

      header.classList.remove('panel-open')

      if (header.classList.contains('fadeout')) {
        header.classList.remove('fadeout')
      }
      header.classList.add('fadein')
      html.classList.remove('slideout-open')

      const nextCard = document.getElementsByClassName('nextComment')

      if (nextCard.length > 0) {
        [].forEach.call(nextCard, (elm) => {
          elm.classList.remove('nextComment')
          elm.style.marginTop = '10px'
        })
      }
      const beforeCard = document.getElementsByClassName('beforeComment')
      if (beforeCard.length > 0) {
        [].forEach.call(beforeCard, elm => {
          elm.classList.remove('beforeComment')
          elm.style.marginBottom = 'auto'
        })
      }
    }

    if (this.state.editMode) {
      const commentCard = document.getElementById(("commentCard" + this.props.comment.id))

      const commentCards = document.getElementsByClassName('commentCard')

      if (commentCards.length > 0) {
        jump(commentCard, {
          offset: -10,
          duration: 200
        })
      }
    }

  }

  render = () => {
    let cardClass, action, overlay, editField, modal
    const currentUser = this.props.currentUser
    const comment = this.props.comment
    
    if (this.state.openModal) {
      modal = (
        <Modal
          okClickHandler={this.deleteConfirm}
          headerTitle='コメントの削除'
          isOpen={this.state.openModal}
          closeModal={this.deleteModalCancel}
          okText='削除する'
        >
          <p>コメントを削除します。<br />本当によろしいですか？</p>
        </Modal>
      )
    }

    if (comment.user.id === currentUser.id) {
      cardClass = 'commentCard ownComment'
      action = (
        <div className='commentActions'>
          <span className='commentDate commentActionItem'>{moment(comment.created_at).fromNow()}</span>
          {(() => {
            if (!this.state.editMode) {
              // return (
              //   <span className='commentEdit commentActionItem'>編集</span>
              // )
            // } else {
              return (
                <span className='commentEdit commentActionItem' onClick={this.editCommentMode}>編集</span>
              )
            }
          })()}
          {(() => {
            if (!this.state.editMode) {
              return (
                <span className='commentDelete commentActionItem' onClick={this.deleteModalOpen} >削除</span>
              )
            }
          })()}
          
        </div>
      )
    } else {
      cardClass = 'commentCard'
      action = (
        <div className='commentActions'>
          <span className='commentDate commentActionItem'>{moment(comment.created_at).fromNow()}</span>
        </div>
      )
    }

    const isMyComment = (comment.user.id === currentUser.id)

    if (this.state.editMode) {
      overlay = (
        <div>
          <div id='menuOverlay' onClick={this.removeEditCommentMode} className='fadein' ></div>
        </div>

      )
      editField = (
        <div className='editCommentField fadein'>
          <textarea name="commentContent" value={this.state.commentContent} onChange={this.valueChange} />

          <input type="submit" className='btn btn-submit  ' value='上記内容で更新' onClick={this.updateComment} />
          <span className='btn btn-white btn-block mt10' onClick={this.removeEditCommentMode}>キャンセル</span>
        </div>
      )

      cardClass += ' openComment'
    }

    return (
      <div className={cardClass} id={"commentCard" + comment.id}>
        {ReactDOM.createPortal(modal, document.getElementById('dialogSpace'))}
        {(() => {
          if (this.state.editMode && isMyComment) {
            return (
              <div>
                {ReactDOM.createPortal(editField, document.getElementById('menuBottomWrap'))}
                {ReactDOM.createPortal(overlay, document.getElementById('contentOverlayWrap'))}
              </div>
            )
          }
        })()
        }
        <div className='userThumb commentThumb' style={{ backgroundImage: `url(${comment.user.photo || defaultUserThumb})` }}></div>
        <div className='commentBody'>
          <span className='commentUserName'>{comment.user.name}</span><br />
          {this.nl2br(comment.content)}
        </div>
        {action}
      </div>
    )
  }

}


// WEBPACK FOOTER //
// ./src/components/Post/CommentCard.jsx